import React from 'react';
import PropTypes from 'prop-types';
import { Button, Container, Grid, Modal } from '@material-ui/core';
import Icons from 'consts/icons';
import { STATUS_COLORS } from 'consts/mapConfig';
import { useSelector } from 'react-redux';
import ConfirmationModal from 'components/common/components/modal/ConfirmationModal';
import { parseDate } from 'utils/main';
import PermissionsGate from 'components/common/PermissionGate';
import { SCOPES } from 'consts/permission-maps';
import { tableStyles } from 'components/common/components/tablev2/CustomizedTableUseStyles';
import { userStyles } from 'consts/styles/User';
import ButtonsUseStyles from 'consts/styles/Buttons';
import Tooltip from '@material-ui/core/Tooltip';
import { formStyles } from 'consts/styles/Form';

const DisplayOperationApprovalDetails = props => {
  const {
    selectedOperation,
    confirmationModalCase,
    setConfirmationModalCase,
    confirmAction,
    handleZoom,
  } = props;
  const subtitles = useSelector(state => state.language).operationsApprovals;
  const timezone = useSelector(state => state.timezone);

  const tableClasses = tableStyles();
  const classesUser = userStyles();
  const classesButtons = ButtonsUseStyles();
  const formClasses = formStyles();

  return (
    <Grid container className={`${classesUser.User}__settings`}>
      <div className={`${classesUser.User}__settings__content__spacer`} />
      <div
        className={`${formClasses.Form}--flex ${formClasses.Form}--flex--direction ${formClasses.Form}--flex--flex-end`}
      >
        <Container>
          <Grid
            container
            spacing={1}
            className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
          >
            <Grid item xs={12}>
              <div className={`${formClasses.Form}__label`}>
                {`${subtitles.uid_}: `}
                <span
                  className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                >
                  {selectedOperation.uid}
                </span>
              </div>
            </Grid>
          </Grid>
        </Container>
        <Container>
          <Grid
            container
            spacing={1}
            className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
          >
            <Grid item xs={9}>
              <div className={`${formClasses.Form}__label`}>
                {subtitles.name_}
              </div>
              <div className={`${formClasses.Form}__text-field`}>
                {selectedOperation.uid.substring(0, 8)}
              </div>
            </Grid>
            <Grid item xs={3} align="right">
              <Tooltip title={subtitles.zoom_} placement="right">
                <Button
                  type="button"
                  fullWidth
                  onClick={() => handleZoom()}
                  className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
                >
                  <Icons.Zoom.ZoomInOnMap />
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
        </Container>
        <Container>
          <Grid
            container
            spacing={1}
            className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between ${formClasses.Form}--height--dashboard-min-height`}
          >
            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.status_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field ${tableClasses.CustomizedTable}__container__table__body__row__cell--status`}
                style={{
                  color: STATUS_COLORS.white,
                  backgroundColor:
                    STATUS_COLORS[selectedOperation.status].stroke,
                  borderColor: STATUS_COLORS[selectedOperation.status].stroke,
                }}
              >
                {selectedOperation.status}
              </span>
            </Grid>
            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.statusUtm_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field ${tableClasses.CustomizedTable}__container__table__body__row__cell--status`}
                style={{
                  color: 'white',
                  backgroundColor:
                    STATUS_COLORS[selectedOperation.operation.status].stroke,
                  borderColor:
                    STATUS_COLORS[selectedOperation.operation.status].stroke,
                }}
              >
                {selectedOperation.operation.status}
              </span>
            </Grid>

            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.start_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {parseDate(selectedOperation.operation.start, timezone)}
              </span>
            </Grid>
            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.stop_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {parseDate(selectedOperation.operation.stop, timezone)}
              </span>
            </Grid>

            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.lon_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {selectedOperation.operation.geojson.coordinates[0]}
              </span>
            </Grid>
            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.lat_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {selectedOperation.operation.geojson.coordinates[1]}
              </span>
            </Grid>

            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.pilot_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {selectedOperation.operation.pilot_id}
              </span>
            </Grid>
            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.operator_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {selectedOperation.operation.operator_id}
              </span>
            </Grid>

            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.flightCategory_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {selectedOperation.operation.flight_category}
              </span>
            </Grid>
            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.subcategory_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {selectedOperation.operation.subcategory || '-'}
              </span>
            </Grid>

            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.weightClass_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {selectedOperation.operation.weight_class}
              </span>
            </Grid>
            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.extraInfo_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {selectedOperation.operation.extra_info || '-'}
              </span>
            </Grid>
          </Grid>
        </Container>
        <Container>
          <PermissionsGate scopes={[SCOPES.canChangeOperationStatus]}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  onClick={() => setConfirmationModalCase(true)}
                  startIcon={<Icons.Actions.Accept />}
                  className={`${formClasses.Form}--width ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} `}
                >
                  {subtitles.confirm_}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={() => setConfirmationModalCase(false)}
                  startIcon={<Icons.Actions.Close />}
                  className={`${formClasses.Form}--width ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} ${classesButtons.Buttons}--reject`}
                >
                  {subtitles.rejection_}
                </Button>
              </Grid>
            </Grid>
          </PermissionsGate>
        </Container>
        <div className={`${classesUser.User}__settings__content__spacer`} />
      </div>
      <Modal
        open={confirmationModalCase !== null}
        onClose={() => setConfirmationModalCase(null)}
      >
        <ConfirmationModal
          setChoice={confirmAction}
          currentStatus={confirmationModalCase}
        />
      </Modal>
    </Grid>
  );
};

export default DisplayOperationApprovalDetails;

DisplayOperationApprovalDetails.propTypes = {
  selectedOperation: PropTypes.object.isRequired,
  confirmationModalCase: PropTypes.bool,
  setConfirmationModalCase: PropTypes.func.isRequired,
  confirmAction: PropTypes.func.isRequired,
  handleZoom: PropTypes.func.isRequired,
};
